"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindStorePage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_helmet_1 = require("react-helmet");
var clinicImage_png_1 = __importDefault(require("../../../assets/clinicImage.png"));
var FindStorePage = function () {
    var _a;
    var locationBankID = (_a = process.env.LOCATION_BANK_CLIENT_ID) !== null && _a !== void 0 ? _a : "";
    (0, react_1.useEffect)(function () {
        setTimeout(function () {
            // Get all serviceMessage elements on the page
            var services = document.getElementsByClassName("serviceMessage");
            // Loop through each serviceMessage elements
            for (var i = 0; i < services.length; i++) {
                // Get serviceMessage innerHTML content
                var service = services[i].innerHTML;
                // If pharmacy has a clinic, add clinic-image class to element
                if (service === "Clinic Available") {
                    //console.log(services[i].classList.add("clinic-available"));
                    services[i].classList.add("pl-8");
                    services[i].classList.add("relative");
                    services[i].innerHTML = services[i].innerHTML + "<img src=".concat(clinicImage_png_1.default, " alt=\"\" class=\"w-[32px] h-[32px] absolute -top-1 left-0\" />");
                    //console.log(services[i].classList.add("bg-clinic-available"));
                }
            }
        }, 5000);
    }, []);
    return (react_1.default.createElement("div", { className: "flex justify-center" },
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("script", { async: true, type: "text/javascript", src: "https://locationbank.net/Public/StoreLocator?id=".concat(locationBankID, "&layout=standard") })),
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
            react_1.default.createElement("div", { id: locationBankID, className: "LB_StoreLocator", style: { height: "90vh", width: "100%" } }))));
};
exports.FindStorePage = FindStorePage;
